export enum TeamPlayersNumber {
  FIVE = 5,
  SIX,
  SEVEN,
  EIGHT,
  NINE,
  TEN,
  ELEVEN
}
